import React, {useEffect, useState} from 'react';
import './CommentList.css';
import '../ProductDetail/ProductDetail';
import {getProducts} from '@/services/commentListFirebaseService';

const CommentList = ({productId}) => {

    const [allCommentId, setAllComments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const loadData = async () => {
            setLoading(true);
            try {
                const data = await getProducts();
                if (data) {
                    setAllComments(data);
                    setHasError(false);
                } else {
                    setHasError(true);
                }
            } catch (error) {
                setHasError(true);
            } finally {
                setLoading(false);
            }
        };
        loadData();
    }, []);

    if (loading) {
        return <div className="loading-state"><p>Cargando opiniones...</p></div>;
    }

    if (hasError) {
        return (
            <main className="product-grid">
                <div className="error-message">
                    <h3>¡Ups! Algo salió mal</h3>
                    <p>No pudimos cargar el catálogo. Inténtalo más tarde.</p>
                </div>
            </main>
        );
    }

    const filteredComments = allCommentId.filter(c => String(c.productId) === String(productId));

    return (
        <div className="detail-container">
            <div className="comments-list">
                {filteredComments.length > 0 ? (
                    filteredComments.map((c) => (
                        <div key={c.id} className="comment-item">
                            <div className="avatar">{c.avatar}</div>
                            <div className="comment-content">
                                <strong>{c.user}</strong> <span className="comment-date">{c.date}</span>
                                <p>{c.text}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div>Aún no hay comentarios para este producto.</div>
                )}
            </div>
        </div>
    );
};

export default CommentList;